import React from 'react';

import { Button, Text } from '@chakra-ui/react';

import { EButtonVariant, EColor, ETextVariant } from '../../../../Theme';
import { ModalContent } from '../../../components';
import { useModalStore } from '../../../stores';
import { EModalContent } from '../../../types';

export const AchTerms = () => {
  const modalStore = useModalStore();

  const handleAccept = () => {
    modalStore.navigate({ name: EModalContent.ADD_US_BANK_ACCOUNT });
  };

  return (
    <ModalContent
      header={
        <Text color={EColor.Black} fontSize="20px" variant={ETextVariant.LG}>
          ACH Terms
        </Text>
      }
    >
      <p className="text-sm text-neutral-700">
        By tapping accept, you authorize Fanatics Collect to securely store your
        bank account information for future ACH transactions. You may remove
        your stored ACH payment method at any time by accessing your account
        settings or contacting cs@fanaticscollect.com.
      </p>
      <Button
        h="56px"
        mt="24px"
        variant={EButtonVariant.BRAND_PRIMARY}
        w="100%"
        onClick={handleAccept}
      >
        Accept
      </Button>
    </ModalContent>
  );
};
